import React from 'react';
import PropTypes from 'prop-types';

import Form from '../Common/Form.react';
import TextField from '../Common/TextField';
import { Card, CardText } from 'material-ui/Card';
import CategorySelector from "./CategorySelector";

import CategoryActions from '../../actions/CategoryActionCreator';
import CategoryStore from '../../stores/CategoryStore';
import { withId } from '../Common/Decorators';


const CategoryForm = React.createClass({

    getInitialState: function () {

        return {
            isEdit: !!this.props.id,
            details: {
                id: '',
                name: '',
                description: '',
                colour: '#38B4AF',
                image: '',
                parentId: '',
                isDefault: null
            },
            categories: [],
            parentId: null
        };
    },

    componentDidMount: function() {
        if (!!this.props.id) {
            this.listener = CategoryStore.addListener(this.onChange);
            CategoryActions.getById(this.props.id);
        }
    },

    componentWillUnmount: function() {
        if (!!this.props.id) {
            CategoryStore.removeChangeListener(this.onChange);
        }
    },

    render: function () {
        const formTitle = (!this.state.isEdit ? 'New' : 'Edit');
        const disabled = !!this.state.isEdit && !!this.state.details.isDefault;

        return(
            <Form title={formTitle}
                onSave={this.onSave}
                redirectTo="/dashboard/library/list"
            >
                <Card className="cent-card">
                    <CardText>
                        <TextField
                            name="name"
                            value={this.state.details.name}
                            validations="minLength:2,maxLength:120"
                            validationError="Please use only letters (max 120)"
                            hintText="Name"
                            floatingLabelText="Name"
                            disabled={disabled}
                            required
                        />
                        <TextField
                            name="description"
                            value={this.state.details.description}
                            multiLine={true}
                            rowsMax={4}
                            hintText="Description"
                            floatingLabelText="Description"
                            disabled={disabled}
                        />
                        {!disabled && (
                            <CategorySelector
                                onConfirmSelection={(parentId) => this.setState({parentId})}
                                options={{canAddSubcategories: true, limit: 0}}
                                defaultCategoryId={!!this.state.isEdit ? Number(this.state.details.parentId) : null}
                            />
                        )}
                        <TextField
                            name="colour"
                            value={this.state.details.colour}
                            validations="minLength:4,maxLength:7"
                            validationError="Please use HEX values (#C9C9C9)"
                            hintText="Colour"
                            floatingLabelText="Colour"
                            floatingLabelFixed={true}
                            disabled={disabled}
                        />
                        <TextField
                            name="image"
                            value={this.state.details.image}
                            validations="minLength:2,maxLength:255"
                            validationError="Please use only letters (max 255)"
                            hintText="Image"
                            floatingLabelText="Image"
                            floatingLabelFixed={true}
                        />
                    </CardText>
                </Card>
            </Form>
        );
    },

    onChange: function() {
        const details = CategoryStore.getById(this.props.id);
        if (details !== undefined) {
            details.parentId = (Number(details.parentId) || null);
            this.setState({details});
        }
    },

    onSave: function (model) {
        model.parentId = this.state.parentId || this.state.details.parentId;

        if (!this.state.isEdit) {
            return CategoryActions.save(model);
        } else {
            return CategoryActions.update(this.props.id, model);
        }
    },


});

CategoryForm.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(CategoryForm);
